import * as React from 'react';
import Layout from './src/components/Layout';
import './src/styles/global.css';
import type { GatsbyBrowser } from 'gatsby';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => (<Layout>{element}</Layout>)
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (<>{element}</>)
